import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetBlocksForCollectionQuery } from '../../../../../services/entities/impl/blfApi/endpoints/collections';
import { Block } from '../../../../../services/entities/impl/blfApi/schemas/block';
import { CollectionPoint } from '../../../types';

export const useGetBlockForCollectionPoint = (
  point: Pick<CollectionPoint, 'blockId' | 'collectionId'>
): { block: Block | undefined; isLoading: boolean } => {
  const { block, isLoading, isFetching } = useGetBlocksForCollectionQuery(
    point.collectionId ?? skipToken,
    {
      selectFromResult: ({ data, isLoading, isFetching }) => {
        return {
          block:
            data?.items.find((block) => block.id === point?.blockId) ??
            undefined,
          isLoading: isLoading,
          isFetching: isFetching,
        };
      },
    }
  );

  return {
    block,
    isLoading: isLoading || isFetching,
  };
};
